(() => {
  document.querySelectorAll('[data-journal]').forEach((root) => {
    const cards = [...root.querySelectorAll('[data-journal-card]')];
    const layout = root.querySelector('[data-journal-layout]');
    const filters = [...root.querySelectorAll('[data-journal-filter]')];
    if (!layout) return;
    filters.forEach((button) => {
      button.addEventListener('click', () => {
        const category = button.dataset.journalFilter;
        filters.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        layout.classList.toggle('is-filtered', category !== 'all');
        let count = 0;
        cards.forEach((card) => {
          card.hidden = category !== 'all' && card.dataset.category !== category;
          if (!card.hidden) count++;
        });
        root.querySelector('[data-journal-empty]').hidden = count > 0;
        root.querySelector('[data-journal-status]').textContent = button.textContent.trim() + ' : ' + count;
      });
    });
  });
})();
